/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Bold_Green_Lynx_PantInputs */

const en_bold_green_lynx_pant = /** @type {(inputs: Bold_Green_Lynx_PantInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ABC-0001`)
};

const de_bold_green_lynx_pant = /** @type {(inputs: Bold_Green_Lynx_PantInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ABC-0001`)
};

/**
* | output |
* | --- |
* | "ABC-0001" |
*
* @param {Bold_Green_Lynx_PantInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const bold_green_lynx_pant = /** @type {((inputs?: Bold_Green_Lynx_PantInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Bold_Green_Lynx_PantInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_bold_green_lynx_pant(inputs)
	return de_bold_green_lynx_pant(inputs)
});